/**
 * `data-testid`, not the legacy `data-test` the rest of the app uses — v3 only, so RTL's `getByTestId`
 * works untouched. It lands on the same element as `data-component`: the interactive one, so
 * `getByTestId('email').fill()` reaches the control rather than a wrapper.
 */
export interface Testable {
	testId?: string;
}

/**
 * For `asChild` slots only. Radix merges slot props onto the child
 */
export function testIdProps(testId?: string) {
	return testId === undefined ? undefined : {'data-testid': testId};
}
